/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';
import Promise from 'bluebird';
import _ from 'underscore';

import {
  Analytics,
  formatContainers,
  getScreenFromUrl,
} from '@trello/atlassian-analytics';
import { isEmbeddedInAtlassian } from '@trello/browser';
import { setDynamicTokens } from '@trello/dynamic-tokens';
import { sendChunkLoadErrorEvent } from '@trello/error-reporting';
import {
  featureFlagClient,
  seesVersionedVariation,
} from '@trello/feature-flag-client';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import {
  getKey,
  Key,
  registerShortcutHandler,
  Scope,
  unregisterShortcutHandler,
} from '@trello/keybindings';
import { showLabelsState } from '@trello/labels';
import ReactDOM from '@trello/react-dom-wrapper';
import { TrelloStorage } from '@trello/storage';
import { getGlobalTheme, GlobalThemeObserver } from '@trello/theme';
import { importWithRetry } from '@trello/use-lazy-component';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { errorPage } from 'app/scripts/controller/errorPage';
import {
  getCurrentBoardViewSection,
  showingBoardView,
  showingCalendar,
} from 'app/scripts/controller/getCurrentBoardView';
import { getQueryParamsToKeepOnBoardView } from 'app/scripts/controller/getQueryParamsToKeepOnBoardView';
import { navigate } from 'app/scripts/controller/navigate';
import { setBoardLocation } from 'app/scripts/controller/setBoardLocation';
import { getBoardUrl } from 'app/scripts/controller/urls';
import { Auth } from 'app/scripts/db/Auth';
import { redoAction, undoAction } from 'app/scripts/lib/last-action';
import { LabelState } from 'app/scripts/view-models/label-state';
import { pluginsChangedSignal } from 'app/scripts/views/internal/plugins/PluginsChangedSignal';
import { View } from 'app/scripts/views/internal/view';
import { Dialog } from 'app/scripts/views/lib/Dialog';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { Layout } from 'app/scripts/views/lib/Layout';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { ListListView } from 'app/scripts/views/list/ListListView';
import { LazyAboutThisBoardModal as AboutThisBoardModal } from 'app/src/components/AboutThisBoardModal';
import { LazyBoardClosed } from 'app/src/components/BoardClosed';
import { BoardSidebarLoadingError } from 'app/src/components/BoardSidebarLoadingError';
import { getBoardBackground } from 'app/src/components/BoardTheme';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { LazyConfirmEmailModal as ConfirmEmailModal } from 'app/src/components/ConfirmEmailModal';
import { filteredCardsCountState } from 'app/src/components/FilterPopover/filteredCardsCountState';
import { LazyInlineInspirationsPopover } from 'app/src/components/InlineInspirations';
import { JoinBoardModal } from 'app/src/components/JoinBoardModal';
import {
  LabelsPopoverState,
  LazyLabelsPopover,
} from 'app/src/components/LabelsPopover';
import { toQueryStringWithDecodedFilterParams } from 'app/src/components/ViewFilters/toQueryStringWithDecodedFilterParams';
import { viewFiltersContextSharedState } from 'app/src/components/ViewFilters/viewFiltersContextSharedState';
import {
  workspaceNavigationHiddenState,
  workspaceNavigationState,
} from 'app/src/components/WorkspaceNavigation';
import {
  clickCloseDirectory,
  closeButler,
  closeCalendar,
  closeDetailView,
  closeDirectory,
  closeMap,
  closePowerUpView,
  dismissFeedback,
  isButlerViewActive,
  isShowingCalendar,
  navigateToBoard,
  navigateToBoardEvent,
  navigateToButler,
  navigateToButlerView,
  navigateToCalendar,
  navigateToCalendarEvent,
  navigateToDirectory,
  navigateToMap,
  navigateToMapEvent,
  reloadCustomFields,
  renderBoardHeaderCalendar,
  renderBoardHeaderMap,
  renderPluginButtons,
  renderPluginDropdownList,
  renderPluginHeaderButtons,
  setButlerView,
  showButlerView,
  showCalendar,
  showDashboard,
  showDirectory,
  showMap,
  showPowerUpView,
  toggleButlerView,
  toggleCalendar,
  toggleDirectory,
  toggleMap,
  unmountPluginDropdownList,
  unmountPluginHeaderButtons,
} from '../plugin/PluginBoardView';
import {
  renderBoardBackground,
  renderBoardHeaderSubscribed,
} from './BoardViewBackground';
import {
  _insertCardPosition,
  copyCardRequested,
  dblClickAddListMenu,
  moveCard,
  moveCardRequested,
  openCardComposerInFirstList,
  preventScrollSelection,
  scrollToCard,
} from './BoardViewCard';
import {
  renderWorkspacesAutoNameAlert,
  unmountWorkspacesAutoNameAlert,
} from './BoardViewCollaboration';
import { copyBoard } from './BoardViewCopy';
import {
  clearFilters,
  clickStar,
  closeAutomaticReports,
  closeSingleBoardView,
  hoverStar,
  initializeFilterCountMonitoring,
  navigateToAutomaticReports,
  removeBoardShareButton,
  removeBoardViewsButton,
  removeBritaBoardFilterButton,
  removeReactBoardHeader,
  removeShowSidebarButton,
  removeSubscribedToBoardHeaderIcon,
  renderBoardHeader,
  renderBoardHeaderStarred,
  renderBoardShareButton,
  renderBritaBoardFilterButton,
  renderButlerBoardButtons,
  renderReactBoardHeader,
  renderShowSidebarButton,
  renderSubscribeIcon,
  renderViewSwitcher,
  showAutomaticReports,
  showCalendarView,
  showCleanUp,
  showTable,
  showTimeline,
  toggleStarred,
} from './BoardViewHeader';
import { renderBoardWarnings } from './BoardViewLimit';
import {
  openListComposer,
  postListListRender,
  renderLists,
  scrollToList,
  sortCommit,
  viewForList,
} from './BoardViewList';
import {
  joinBoard,
  onMemberAdd,
  openAddMembers,
  openAllMembers,
  renderBoardHeaderFacepile,
  showMemberProfile,
} from './BoardViewMember';
import {
  keyDownEvent,
  onInputChanged,
  saveBoardName,
  startRenaming,
  stopRenaming,
  updateControllerTitle,
} from './BoardViewName';
import { markRelatedNotificationsRead } from './BoardViewNotifications';
import { _delete, reopen } from './BoardViewOpenCloseDelete';
import { refreshOrganization, renderOrgChanges } from './BoardViewOrganization';
import {
  changeVis,
  permChange,
  renderPermissionLevel,
} from './BoardViewPermission';
import {
  _applySettings,
  _isFirstBoardEverLoaded,
  _isGhostUsingInviteLink,
  _shouldCloseBoardMenu,
  hideSidebar,
  removeSidebarDisplayTypes,
  renderOpen,
  renderSidebarDisplayType,
  renderSidebarState,
  setSidebarShow,
  showSidebar,
  showSidebarOnOpen,
  toggleSidebar,
} from './BoardViewSidebar';
import {
  renderTeamOnboardingPupPopover,
  renderTeamOnboardingPupTooltip,
  unmountTeamOnboardingPupPopover,
  unmountTeamOnboardingPupTooltip,
} from './BoardViewTeamOnboardingPups';
import {
  isTemplate,
  renderBoardTemplateBadge,
  renderBoardTemplateReactSection,
} from './BoardViewTemplate';
import { openUnsubscribe } from './BoardViewUnsubscribe';

interface BoardView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _applySettings: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  calcState: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  calendarView: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  closeCalendar: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  closeMap: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  collectionSubview: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  copyCardRequested: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  globalThemeObserver: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headerBranding: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ignoreMouseCardSelects: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initializeFilterCountMonitoring: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inlineInspirationsPopoverDiv: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isLoadingPowerUpViews: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listListView: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listRenderingMode: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listScrollLeft: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listenTo: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  makeDebouncedMethods: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  markRelatedNotificationsRead: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  memberTypeMe: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  moveCard: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  moveCardRequested: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onMemberAdd: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openCardComposerInFirstList: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openListComposer: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  permChange: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  postListListRender: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  powerUpViews: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  refreshOrganization: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  refreshOrganizationDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reloadCustomFieldsDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reloadDirectoryPlugins: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeBoardShareButton: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeBoardViewsButton: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeBritaBoardFilterButton: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeReactBoardHeader: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeShowSidebarButton: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeSubscribedToBoardHeaderIcon: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBoardBackground: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBoardBackgroundDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBoardHeaderCalendarDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBoardHeaderDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBoardHeaderFacepileDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBoardHeaderMapDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBoardHeaderStarred: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBoardHeaderSubscribedDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBoardWarningsDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderListsDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderOpen: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderPermissionLevelDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderPluginButtonsDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderPluginDropdownListDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderPluginHeaderButtonsDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderSidebarDisplayType: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderSidebarState: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderViewSwitcherDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  savingScroll: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setDynamicTokensOnBoardViewDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  shouldRenderPartialReactBoardHeader: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showAutomaticReports: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showButlerView: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showCalendar: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showCalendarView: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showDashboard: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showDirectory: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showMap: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showMemberProfile: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showPowerUpView: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showTable: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showTimeline: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sidebarView: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sidebarViewPromise: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subscribe: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subview: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  teamOnboardingPupPopoverDiv: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  teamOnboardingPupTooltipDiv: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toggleSidebar: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountBoardClosed: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountConfirmEmailModal: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountJoinBoardModal: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountLabelsPopover: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountLists: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountPluginDropdownList: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountPluginHeaderButtons: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountTeamOnboardingPupPopover: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountTeamOnboardingPupTooltip: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountWorkspacesAutoNameAlert: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unsubscribeViewFiltersContext: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unsubscribeWorkspaceNavHiddenState: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unsubscribeWorkspaceNavState: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateControllerTitleDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  workspaceNavState: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  workspacesAutoNameAlertTarget: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}

// @ts-expect-error TS(2707): Generic type 'View<TOptions, TModel>' requires bet... Remove this comment to see the full error message
class BoardView extends View {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'className' does not exist on type 'Board... Remove this comment to see the full error message
    this.prototype.className = 'board-wrapper';

    // @ts-expect-error TS(2339): Property 'displayName' does not exist on type 'Boa... Remove this comment to see the full error message
    this.prototype.displayName = 'BoardView';

    // @ts-expect-error TS(2339): Property 'events' does not exist on type 'BoardVie... Remove this comment to see the full error message
    this.prototype.events = {
      sortcommit: 'sortCommit',

      // For renaming boards in modern browsers
      'keydown .js-board-name-input': 'keyDownEvent',
      'input .js-board-name-input': 'onInputChanged',
      'change .js-board-name-input': 'onInputChanged',
      // Firefox uses "change" rather than "input"
      'blur .js-board-name-input': 'stopRenaming',
      'click .js-board-editing-target': 'startRenaming',

      'click .js-change-vis': 'changeVis',
      'click .js-close-calendar': 'toggleCalendar',
      'click .js-calendar': 'toggleCalendar',
      'click .js-disable-feedback': 'dismissFeedback',
      'click .js-close-map': 'toggleMap',
      'click .js-map-btn': 'toggleMap',
      'click .js-close-dashboard': 'navigateToBoard',

      'click .js-board-header-subscribed': 'openUnsubscribe',

      'click .js-star-board': 'toggleStarred',
      'mouseover .js-star-board': 'hoverStar',
      'mouseout .js-star-board': 'renderBoardHeaderStarred',
      'mousedown .js-star-board': 'clickStar',

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      'click .js-dismiss-warning'(e: any) {
        TrelloStorage.set(
          // @ts-expect-error TS(2339): Property 'attr' does not exist on type 'JQueryStat... Remove this comment to see the full error message
          $(e.currentTarget, this.$el).attr('data-dismiss'),
          Date.now(),
        );
        return this.renderBoardWarnings();
      },

      'dblclick #board': 'dblClickAddListMenu',
      'click #board': 'blurInputsOnBoardClick',

      'click .js-reopen': 'reopen',
      'click .js-delete': 'delete',

      'click .js-clean-up': 'showCleanUp',

      'prevent-scroll-selection': 'preventScrollSelection',

      'click .js-close-directory': 'clickCloseDirectory',

      'click .js-copy-board': 'copyBoard',
      'click .js-open-show-all-board-members': 'openAllMembers',
      'click .js-join-board': 'joinBoard',
    };

    this.prototype.onMemberAdd = onMemberAdd;

    // @ts-expect-error TS(2339): Property 'isTemplate' does not exist on type 'Boar... Remove this comment to see the full error message
    this.prototype.isTemplate = isTemplate;

    // @ts-expect-error TS(2339): Property 'renderBoardTemplateReactSection' does no... Remove this comment to see the full error message
    this.prototype.renderBoardTemplateReactSection = renderBoardTemplateReactSection;

    // @ts-expect-error TS(2339): Property 'renderBoardTemplateBadge' does not exist... Remove this comment to see the full error message
    this.prototype.renderBoardTemplateBadge = renderBoardTemplateBadge;

    this.prototype._applySettings = _applySettings;

    this.prototype.permChange = permChange;

    this.prototype.openListComposer = openListComposer;

    this.prototype.openCardComposerInFirstList = openCardComposerInFirstList;

    // @ts-expect-error TS(2339): Property 'scrollToList' does not exist on type 'Bo... Remove this comment to see the full error message
    this.prototype.scrollToList = scrollToList;

    // @ts-expect-error TS(2339): Property 'viewForList' does not exist on type 'Boa... Remove this comment to see the full error message
    this.prototype.viewForList = viewForList;

    // @ts-expect-error TS(2339): Property 'scrollToCard' does not exist on type 'Bo... Remove this comment to see the full error message
    this.prototype.scrollToCard = scrollToCard;

    // @ts-expect-error TS(2339): Property 'preventScrollSelection' does not exist o... Remove this comment to see the full error message
    this.prototype.preventScrollSelection = preventScrollSelection;

    this.prototype.markRelatedNotificationsRead = markRelatedNotificationsRead;

    this.prototype.moveCard = moveCard;

    // @ts-expect-error TS(2551): Property 'renderTeamOnboardingPupPopover' does not... Remove this comment to see the full error message
    this.prototype.renderTeamOnboardingPupPopover = renderTeamOnboardingPupPopover;

    // @ts-expect-error TS(2551): Property 'renderTeamOnboardingPupTooltip' does not... Remove this comment to see the full error message
    this.prototype.renderTeamOnboardingPupTooltip = renderTeamOnboardingPupTooltip;

    this.prototype.unmountTeamOnboardingPupPopover = unmountTeamOnboardingPupPopover;
    this.prototype.unmountTeamOnboardingPupTooltip = unmountTeamOnboardingPupTooltip;

    // @ts-expect-error TS(2339): Property '_shouldCloseBoardMenu' does not exist on... Remove this comment to see the full error message
    this.prototype._shouldCloseBoardMenu = _shouldCloseBoardMenu;

    // @ts-expect-error TS(2339): Property '_isFirstBoardEverLoaded' does not exist ... Remove this comment to see the full error message
    this.prototype._isFirstBoardEverLoaded = _isFirstBoardEverLoaded;

    // @ts-expect-error TS(2339): Property '_isGhostUsingInviteLink' does not exist ... Remove this comment to see the full error message
    this.prototype._isGhostUsingInviteLink = _isGhostUsingInviteLink;

    this.prototype.renderOpen = renderOpen;

    // @ts-expect-error TS(2551): Property 'removeSidebarDisplayTypes' does not exis... Remove this comment to see the full error message
    this.prototype.removeSidebarDisplayTypes = removeSidebarDisplayTypes;

    this.prototype.renderSidebarDisplayType = renderSidebarDisplayType;

    // @ts-expect-error TS(2339): Property 'showSidebarOnOpen' does not exist on typ... Remove this comment to see the full error message
    this.prototype.showSidebarOnOpen = showSidebarOnOpen;

    this.prototype.renderSidebarState = renderSidebarState;

    this.prototype.toggleSidebar = toggleSidebar;

    // @ts-expect-error TS(2339): Property 'setSidebarShow' does not exist on type '... Remove this comment to see the full error message
    this.prototype.setSidebarShow = setSidebarShow;

    // @ts-expect-error TS(2339): Property 'showSidebar' does not exist on type 'Boa... Remove this comment to see the full error message
    this.prototype.showSidebar = showSidebar;

    // @ts-expect-error TS(2339): Property 'hideSidebar' does not exist on type 'Boa... Remove this comment to see the full error message
    this.prototype.hideSidebar = hideSidebar;

    // @ts-expect-error TS(2339): Property 'renderOrgChanges' does not exist on type... Remove this comment to see the full error message
    this.prototype.renderOrgChanges = renderOrgChanges;

    this.prototype.refreshOrganization = refreshOrganization;

    // @ts-expect-error TS(2339): Property 'reloadCustomFields' does not exist on ty... Remove this comment to see the full error message
    this.prototype.reloadCustomFields = reloadCustomFields;

    // @ts-expect-error TS(2339): Property 'renderBoardHeader' does not exist on typ... Remove this comment to see the full error message
    this.prototype.renderBoardHeader = renderBoardHeader;

    // @ts-expect-error TS(2551): Property 'renderReactBoardHeader' does not exist o... Remove this comment to see the full error message
    this.prototype.renderReactBoardHeader = renderReactBoardHeader;

    this.prototype.removeReactBoardHeader = removeReactBoardHeader;

    // @ts-expect-error TS(2339): Property 'renderSubscribeIcon' does not exist on t... Remove this comment to see the full error message
    this.prototype.renderSubscribeIcon = renderSubscribeIcon;

    // @ts-expect-error TS(2339): Property 'renderBoardWarnings' does not exist on t... Remove this comment to see the full error message
    this.prototype.renderBoardWarnings = renderBoardWarnings;

    // @ts-expect-error TS(2339): Property 'renderPluginButtons' does not exist on t... Remove this comment to see the full error message
    this.prototype.renderPluginButtons = renderPluginButtons;

    this.prototype.renderBoardHeaderStarred = renderBoardHeaderStarred;

    // @ts-expect-error TS(2339): Property 'hoverStar' does not exist on type 'Board... Remove this comment to see the full error message
    this.prototype.hoverStar = hoverStar;

    // @ts-expect-error TS(2339): Property 'clickStar' does not exist on type 'Board... Remove this comment to see the full error message
    this.prototype.clickStar = clickStar;

    // @ts-expect-error TS(2339): Property 'toggleStarred' does not exist on type 'B... Remove this comment to see the full error message
    this.prototype.toggleStarred = toggleStarred;

    // @ts-expect-error TS(2551): Property 'renderBoardHeaderCalendar' does not exis... Remove this comment to see the full error message
    this.prototype.renderBoardHeaderCalendar = renderBoardHeaderCalendar;

    // @ts-expect-error TS(2339): Property 'renderPluginDropdownList' does not exist... Remove this comment to see the full error message
    this.prototype.renderPluginDropdownList = renderPluginDropdownList;

    // @ts-expect-error TS(2339): Property 'renderPluginHeaderButtons' does not exis... Remove this comment to see the full error message
    this.prototype.renderPluginHeaderButtons = renderPluginHeaderButtons;

    this.prototype.unmountPluginDropdownList = unmountPluginDropdownList;

    this.prototype.unmountPluginHeaderButtons = unmountPluginHeaderButtons;

    this.prototype.renderBoardBackground = renderBoardBackground;

    // @ts-expect-error TS(2339): Property 'renderBoardHeaderSubscribed' does not ex... Remove this comment to see the full error message
    this.prototype.renderBoardHeaderSubscribed = renderBoardHeaderSubscribed;

    // @ts-expect-error TS(2339): Property 'renderViewSwitcher' does not exist on ty... Remove this comment to see the full error message
    this.prototype.renderViewSwitcher = renderViewSwitcher;

    this.prototype.removeBoardViewsButton = removeBoardViewsButton;

    // @ts-expect-error TS(2339): Property 'saveBoardName' does not exist on type 'B... Remove this comment to see the full error message
    this.prototype.saveBoardName = saveBoardName;

    // @ts-expect-error TS(2339): Property 'keyDownEvent' does not exist on type 'Bo... Remove this comment to see the full error message
    this.prototype.keyDownEvent = keyDownEvent;

    // @ts-expect-error TS(2339): Property 'onInputChanged' does not exist on type '... Remove this comment to see the full error message
    this.prototype.onInputChanged = onInputChanged;

    // @ts-expect-error TS(2339): Property 'startRenaming' does not exist on type 'B... Remove this comment to see the full error message
    this.prototype.startRenaming = startRenaming;

    // @ts-expect-error TS(2339): Property 'stopRenaming' does not exist on type 'Bo... Remove this comment to see the full error message
    this.prototype.stopRenaming = stopRenaming;

    // @ts-expect-error TS(2339): Property 'renderPermissionLevel' does not exist on... Remove this comment to see the full error message
    this.prototype.renderPermissionLevel = renderPermissionLevel;

    this.prototype.postListListRender = postListListRender;

    // @ts-expect-error TS(2339): Property 'renderLists' does not exist on type 'Boa... Remove this comment to see the full error message
    this.prototype.renderLists = renderLists;

    // @ts-expect-error TS(2339): Property 'sortCommit' does not exist on type 'Boar... Remove this comment to see the full error message
    this.prototype.sortCommit = sortCommit;

    // @ts-expect-error TS(2339): Property 'renderBoardHeaderFacepile' does not exis... Remove this comment to see the full error message
    this.prototype.renderBoardHeaderFacepile = renderBoardHeaderFacepile;

    // @ts-expect-error TS(2339): Property 'openAllMembers' does not exist on type '... Remove this comment to see the full error message
    this.prototype.openAllMembers = openAllMembers;

    // @ts-expect-error TS(2339): Property 'openAddMembers' does not exist on type '... Remove this comment to see the full error message
    this.prototype.openAddMembers = openAddMembers;

    // @ts-expect-error TS(2339): Property 'joinBoard' does not exist on type 'Board... Remove this comment to see the full error message
    this.prototype.joinBoard = joinBoard;

    // @ts-expect-error TS(2339): Property 'changeVis' does not exist on type 'Board... Remove this comment to see the full error message
    this.prototype.changeVis = changeVis;

    // @ts-expect-error TS(2339): Property 'toggleCalendar' does not exist on type '... Remove this comment to see the full error message
    this.prototype.toggleCalendar = toggleCalendar;

    // @ts-expect-error TS(2339): Property 'dismissFeedback' does not exist on type ... Remove this comment to see the full error message
    this.prototype.dismissFeedback = dismissFeedback;

    // @ts-expect-error TS(2339): Property 'navigateToCalendarEvent' does not exist ... Remove this comment to see the full error message
    this.prototype.navigateToCalendarEvent = navigateToCalendarEvent;

    // @ts-expect-error TS(2339): Property 'navigateToCalendar' does not exist on ty... Remove this comment to see the full error message
    this.prototype.navigateToCalendar = navigateToCalendar;

    // @ts-expect-error TS(2339): Property 'navigateToBoardEvent' does not exist on ... Remove this comment to see the full error message
    this.prototype.navigateToBoardEvent = navigateToBoardEvent;

    // @ts-expect-error TS(2339): Property 'navigateToBoard' does not exist on type ... Remove this comment to see the full error message
    this.prototype.navigateToBoard = navigateToBoard;

    // @ts-expect-error TS(2339): Property 'isShowingCalendar' does not exist on typ... Remove this comment to see the full error message
    this.prototype.isShowingCalendar = isShowingCalendar;

    // @ts-expect-error TS(2339): Property 'toggleMap' does not exist on type 'Board... Remove this comment to see the full error message
    this.prototype.toggleMap = toggleMap;

    // @ts-expect-error TS(2339): Property 'navigateToMapEvent' does not exist on ty... Remove this comment to see the full error message
    this.prototype.navigateToMapEvent = navigateToMapEvent;

    // @ts-expect-error TS(2339): Property 'navigateToMap' does not exist on type 'B... Remove this comment to see the full error message
    this.prototype.navigateToMap = navigateToMap;

    // @ts-expect-error TS(2339): Property 'isButlerViewActive' does not exist on ty... Remove this comment to see the full error message
    this.prototype.isButlerViewActive = isButlerViewActive;

    // @ts-expect-error TS(2339): Property 'toggleButlerView' does not exist on type... Remove this comment to see the full error message
    this.prototype.toggleButlerView = toggleButlerView;

    this.prototype.showButlerView = showButlerView;

    // @ts-expect-error TS(2551): Property 'setButlerView' does not exist on type 'B... Remove this comment to see the full error message
    this.prototype.setButlerView = setButlerView;

    // @ts-expect-error TS(2339): Property 'navigateToButler' does not exist on type... Remove this comment to see the full error message
    this.prototype.navigateToButler = navigateToButler;

    // @ts-expect-error TS(2339): Property 'navigateToButlerView' does not exist on ... Remove this comment to see the full error message
    this.prototype.navigateToButlerView = navigateToButlerView;

    this.prototype.showMemberProfile = showMemberProfile;

    this.prototype.showCalendar = showCalendar;

    this.prototype.showMap = showMap;

    this.prototype.showPowerUpView = showPowerUpView;

    // @ts-expect-error TS(2339): Property 'closePowerUpView' does not exist on type... Remove this comment to see the full error message
    this.prototype.closePowerUpView = closePowerUpView;

    this.prototype.showDashboard = showDashboard;

    // @ts-expect-error TS(2339): Property 'closeDetailView' does not exist on type ... Remove this comment to see the full error message
    this.prototype.closeDetailView = closeDetailView;

    this.prototype.closeCalendar = closeCalendar;

    this.prototype.closeMap = closeMap;

    // @ts-expect-error TS(2339): Property 'closeButler' does not exist on type 'Boa... Remove this comment to see the full error message
    this.prototype.closeButler = closeButler;

    // @ts-expect-error TS(2339): Property 'clickCloseDirectory' does not exist on t... Remove this comment to see the full error message
    this.prototype.clickCloseDirectory = clickCloseDirectory;

    // @ts-expect-error TS(2339): Property 'toggleDirectory' does not exist on type ... Remove this comment to see the full error message
    this.prototype.toggleDirectory = toggleDirectory;

    // @ts-expect-error TS(2339): Property 'navigateToDirectory' does not exist on t... Remove this comment to see the full error message
    this.prototype.navigateToDirectory = navigateToDirectory;

    this.prototype.showDirectory = showDirectory;

    // @ts-expect-error TS(2339): Property 'closeDirectory' does not exist on type '... Remove this comment to see the full error message
    this.prototype.closeDirectory = closeDirectory;

    this.prototype.showTimeline = showTimeline;

    this.prototype.showCalendarView = showCalendarView;

    this.prototype.showTable = showTable;

    // @ts-expect-error TS(2339): Property 'closeSingleBoardView' does not exist on ... Remove this comment to see the full error message
    this.prototype.closeSingleBoardView = closeSingleBoardView;

    // @ts-expect-error TS(2551): Property 'renderBritaBoardFilterButton' does not e... Remove this comment to see the full error message
    this.prototype.renderBritaBoardFilterButton = renderBritaBoardFilterButton;

    this.prototype.removeBritaBoardFilterButton = removeBritaBoardFilterButton;

    // @ts-expect-error TS(2551): Property 'renderShowSidebarButton' does not exist ... Remove this comment to see the full error message
    this.prototype.renderShowSidebarButton = renderShowSidebarButton;

    this.prototype.removeShowSidebarButton = removeShowSidebarButton;

    this.prototype.removeSubscribedToBoardHeaderIcon = removeSubscribedToBoardHeaderIcon;

    // @ts-expect-error TS(2551): Property 'renderBoardShareButton' does not exist o... Remove this comment to see the full error message
    this.prototype.renderBoardShareButton = renderBoardShareButton;

    this.prototype.removeBoardShareButton = removeBoardShareButton;

    // @ts-expect-error TS(2339): Property 'clearFilters' does not exist on type 'Bo... Remove this comment to see the full error message
    this.prototype.clearFilters = clearFilters;

    // @ts-expect-error TS(2339): Property 'openUnsubscribe' does not exist on type ... Remove this comment to see the full error message
    this.prototype.openUnsubscribe = openUnsubscribe;

    // @ts-expect-error TS(2339): Property 'dblClickAddListMenu' does not exist on t... Remove this comment to see the full error message
    this.prototype.dblClickAddListMenu = dblClickAddListMenu;

    // @ts-expect-error TS(2339): Property 'reopen' does not exist on type 'BoardVie... Remove this comment to see the full error message
    this.prototype.reopen = reopen;

    // @ts-expect-error TS(2339): Property 'delete' does not exist on type 'BoardVie... Remove this comment to see the full error message
    this.prototype.delete = _delete;

    // @ts-expect-error TS(2339): Property 'updateControllerTitle' does not exist on... Remove this comment to see the full error message
    this.prototype.updateControllerTitle = updateControllerTitle;

    // @ts-expect-error TS(2339): Property 'copyBoard' does not exist on type 'Board... Remove this comment to see the full error message
    this.prototype.copyBoard = copyBoard;

    // @ts-expect-error TS(2339): Property '_insertCardPosition' does not exist on t... Remove this comment to see the full error message
    this.prototype._insertCardPosition = _insertCardPosition;

    this.prototype.moveCardRequested = moveCardRequested;

    this.prototype.copyCardRequested = copyCardRequested;

    // @ts-expect-error TS(2339): Property 'showCleanUp' does not exist on type 'Boa... Remove this comment to see the full error message
    this.prototype.showCleanUp = showCleanUp;

    // @ts-expect-error TS(2339): Property 'renderBoardHeaderMap' does not exist on ... Remove this comment to see the full error message
    this.prototype.renderBoardHeaderMap = renderBoardHeaderMap;

    // @ts-expect-error TS(2551): Property 'renderWorkspacesAutoNameAlert' does not ... Remove this comment to see the full error message
    this.prototype.renderWorkspacesAutoNameAlert = renderWorkspacesAutoNameAlert;

    this.prototype.unmountWorkspacesAutoNameAlert = unmountWorkspacesAutoNameAlert;

    // @ts-expect-error TS(2339): Property 'renderButlerBoardButtons' does not exist... Remove this comment to see the full error message
    this.prototype.renderButlerBoardButtons = renderButlerBoardButtons;

    // @ts-expect-error TS(2339): Property 'navigateToAutomaticReports' does not exi... Remove this comment to see the full error message
    this.prototype.navigateToAutomaticReports = navigateToAutomaticReports;

    this.prototype.showAutomaticReports = showAutomaticReports;

    // @ts-expect-error TS(2551): Property 'closeAutomaticReports' does not exist on... Remove this comment to see the full error message
    this.prototype.closeAutomaticReports = closeAutomaticReports;

    this.prototype.initializeFilterCountMonitoring = initializeFilterCountMonitoring;

    this.prototype.shouldRenderPartialReactBoardHeader = seesVersionedVariation(
      'panorama.board-header-rewrite',
      'alpha',
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor({ headerBranding }: any) {
    super(...arguments);
    this.headerBranding = headerBranding;
    this.onShortcut = this.onShortcut.bind(this);
    this.renderConfirmEmailModal = this.renderConfirmEmailModal.bind(this);
    this.isLoadingPowerUpViews = true;
    this.powerUpViews = [];
    registerShortcutHandler(this.onShortcut, { scope: Scope.Board });
  }

  initialize() {
    super.initialize(...arguments);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const assignSubview = (module: any) => {
      return (this.sidebarView = this.subview(
        module.BoardSidebarView,
        this.model,
        {
          boardView: this,
        },
      ));
    };
    this.sidebarViewPromise = importWithRetry(
      () =>
        import(
          /* webpackChunkName: "board-sidebar-view" */ 'app/scripts/views/board-menu/BoardSidebarView'
        ),
    )
      .then(assignSubview.bind(this))
      .catch(function (error) {
        if (error.name === 'ChunkLoadError') {
          sendChunkLoadErrorEvent(error);
          const container = document.querySelector('.board-menu');
          if (container) {
            return renderComponent(<BoardSidebarLoadingError />, container);
          }
        } else {
          throw error;
        }
      });

    // setting this property is needed because board-view-sidebar reads from this
    this.workspaceNavState = workspaceNavigationState.value;
    const toggleCollapsedClass = () => {
      this.workspaceNavState = workspaceNavigationState.value;
      if (
        !workspaceNavigationHiddenState.value.hidden &&
        !workspaceNavigationState.value.expanded &&
        // this class adds extra padding and workspace nav is hidden
        // by default when the board is embedded
        !isEmbeddedInAtlassian()
      ) {
        $('#board').addClass('collapsed-workspace-nav');
        $('.js-board-header').addClass('collapsed-workspace-nav');
      } else {
        $('#board').removeClass('collapsed-workspace-nav');
        $('.js-board-header').removeClass('collapsed-workspace-nav');
      }
    };
    this.unsubscribeWorkspaceNavState = workspaceNavigationState.subscribe(
      toggleCollapsedClass,
    );
    this.unsubscribeWorkspaceNavHiddenState = workspaceNavigationHiddenState.subscribe(
      toggleCollapsedClass,
    );

    this.teamOnboardingPupPopoverDiv = null;
    this.inlineInspirationsPopoverDiv = null;
    this.teamOnboardingPupTooltipDiv = null;
    this.workspacesAutoNameAlertTarget = null;

    this.makeDebouncedMethods(
      'refreshOrganization',
      'reloadCustomFields',
      'render',
      'renderBoardBackground',
      'renderBoardHeader',
      'renderBoardHeaderCalendar',
      'renderPluginDropdownList',
      'renderPluginHeaderButtons',
      'renderBoardHeaderSubscribed',
      'renderBoardHeaderMap',
      'renderBoardWarnings',
      'renderLists',
      'renderPermissionLevel',
      'updateControllerTitle',
      'renderBoardHeaderFacepile',
      'renderPluginButtons',
      'renderViewSwitcher',
      'renderBritaBoardFilterButton',
      'renderBoardShareButton',
      'renderShowSidebarButton',
      'setDynamicTokensOnBoardView',
    );

    this.listenTo(this.model, {
      'change:closed deleting': this.renderDebounced,
      'change:idOrganization': () => {
        this.reloadDirectoryPlugins = true;
        this.refreshOrganizationDebounced();
        return this.headerBranding();
      },
      'change:memberships': this.renderPermissionLevelDebounced,
      'change:limits': this.renderBoardWarningsDebounced,
      'change:myPrefs': () => {
        this.renderBoardHeaderDebounced();
      },
      'change:name': () => {
        this.renderBoardHeaderDebounced();
        return this.updateControllerTitleDebounced();
      },
      'change:powerUps'() {
        if (this.shouldRenderPartialReactBoardHeader) {
          this.renderBoardHeaderDebounced();
        }
        if (!this.shouldRenderPartialReactBoardHeader) {
          this.renderBoardHeaderMapDebounced();
          this.renderBoardHeaderCalendarDebounced();
          this.renderPluginDropdownListDebounced();
        }
        if (!this.model.isMapPowerUpEnabled()) {
          this.closeMap();
        }
        if (!this.model.isPowerUpEnabled('calendar')) {
          return this.closeCalendar();
        }
        this.renderPluginHeaderButtonsDebounced();
      },
      'change:prefs.cardCovers': this.renderListsDebounced,
      'change:prefs.permissionLevel': () => {
        this.renderListsDebounced();
        this.renderPermissionLevelDebounced();
        return this.renderBoardHeaderDebounced();
      },
      'change:prefs.background change:prefs.backgroundTile change:prefs.backgroundBrightness': () => {
        this.renderBoardBackgroundDebounced(true);
        this.renderBoardHeaderDebounced();
        if (!this.shouldRenderPartialReactBoardHeader) {
          this.renderBoardHeaderCalendarDebounced();
          this.renderPluginDropdownListDebounced();
        }
        this.renderPluginHeaderButtonsDebounced();
        this.renderPluginButtonsDebounced();
        this.setDynamicTokensOnBoardViewDebounced();
      },
      'change:prefs.isTemplate': this.renderBoardHeaderDebounced,
      'change:prefs.selfJoin': this.renderBoardHeaderDebounced,
      'change:subscribed': this.renderBoardHeaderSubscribedDebounced,
      permChange: this.permChange,
      ownedChange: this.renderBoardHeaderDebounced,
      destroy: () => {
        return errorPage({
          errorType: 'boardNotFound',
        });
      },
    });

    this.listenTo(this.model.memberList, {
      'change:status': this.renderBoardHeaderDebounced,
      add: this.onMemberAdd,
      'remove reset': this.renderBoardHeaderFacepileDebounced,
    });

    this.listenTo(this.model.boardPluginList, 'add reset', () => {
      if (this.shouldRenderPartialReactBoardHeader) {
        this.renderBoardHeaderDebounced();
      }
      if (!this.shouldRenderPartialReactBoardHeader) {
        this.renderPluginDropdownListDebounced();
      }
      this.renderPluginHeaderButtonsDebounced();
      this.reloadCustomFieldsDebounced();
      return this.renderViewSwitcherDebounced();
    });

    this.subscribe(pluginsChangedSignal(this.model), () => {
      if (!this.shouldRenderPartialReactBoardHeader) {
        this.renderPluginDropdownListDebounced();
        this.renderBoardHeaderMapDebounced();
        this.renderBoardHeaderCalendarDebounced();
      }
      this.renderPluginHeaderButtonsDebounced();
      if (this.shouldRenderPartialReactBoardHeader) {
        this.renderBoardHeaderDebounced();
      }
      if (!this.model.isMapPowerUpEnabled()) {
        this.closeMap();
      }
      if (!this.model.isPowerUpEnabled('calendar')) {
        this.closeCalendar();
      }

      return this.renderViewSwitcherDebounced();
    });

    this.listenTo(this.model.viewState, {
      'change:showSidebar': this.renderSidebarState,
      'change:sidebarDisplayType': this.renderSidebarDisplayType,
    });

    this.listenTo(Auth.me().boardStarList, 'add remove reset', () => {
      return this.renderBoardHeaderStarred();
    });

    this.memberTypeMe = this.model.getMemberType(Auth.me());

    this.refreshOrganization();

    this.listScrollLeft = null;
    this.savingScroll = false;
    this.calcState = {};

    filteredCardsCountState.setValue({ count: 0, isLoading: false });
    this.initializeFilterCountMonitoring();

    this.listenTo(this.model.filter, 'change', () => {
      this.renderFilteringStatus();
    });

    this.listRenderingMode = featureFlagClient.get(
      'fep.board-canvas-modernization.lists',
      false,
    )
      ? 'react'
      : 'backbone';

    if (this.listRenderingMode === 'backbone') {
      this.listListView = this.collectionSubview(
        ListListView,
        this.model.listList,
        {
          id: 'board',
          model: this.model,
          className: `u-fancy-scrollbar js-no-higher-edits ${
            !workspaceNavigationHiddenState.value.hidden &&
            !workspaceNavigationState.value.expanded
              ? 'collapsed-workspace-nav'
              : ''
          }`,
          resetCallback: () => this.postListListRender(),
        },
      );

      // Why are we listening to mousemove? Isn't mouseenter sufficient?
      //
      // 1. Hover your mouse over a card
      // 2. Hit an arrow key, moving the selected card, but not in a way that
      //    scrolls the page -- so the mouse is still hovering over the original
      //    card view.
      // 3. Move your mouse.
      //
      // If we were only listening to mouseenter, we'd never select the card,
      // because the mouse didn't re-enter it.
      this.listenTo(this.listListView, {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mouseMoveListView(listView: any) {
          return this.model.viewState.selectList(listView.model);
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mouseLeaveListView(listView: any) {
          return this.model.viewState.selectList(null);
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mouseMoveCardView(listView: any, cardView: any) {
          if (this._ignoreMouseMove()) {
            return;
          }
          return this.model.viewState.selectCard(cardView.model);
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mouseLeaveCardView(listView: any, cardView: any) {
          if (this._ignoreMouseMove()) {
            return;
          }
          return this.model.viewState.selectCard(null);
        },
        moveCard: this.moveCardRequested,
        copyCard: this.copyCardRequested,
      });
    }

    this._applySettings();
    this.markRelatedNotificationsRead();

    this.reloadDirectoryPlugins = false;

    // Rerender the board header when the global theme changes.
    // This is used to update the `setDynamicTokens` call.
    // When the board header is migrated to React, all of this will be handled
    // by the `useDynamicTokens` hook.
    this.globalThemeObserver = new GlobalThemeObserver(() =>
      // Optional only to protect from the very niche outside possibility that
      // we somehow trigger this event before `makeDebouncedMethods` resolves.
      this.setDynamicTokensOnBoardViewDebounced?.(),
    );

    const { colorMode, effectiveColorMode } = getGlobalTheme();

    // Analytics migration -- move this to controller to capture all URL changes
    Analytics.sendMarketingScreenEvent({
      source: 'boardScreen',
      name: 'boardScreenV2',
      attributes: {
        // When the workflowers.ads-tokens feature flag is enabled, we want to
        // track whether the user is enrolled in a theme. In this case, 'none'
        // represents that the user has explicitly opted out of themes.
        colorMode: featureFlagClient.get('workflowers.ads-tokens', false)
          ? colorMode ?? 'none'
          : null,
        effectiveColorMode,
        isColorBlindModeEnabled: Auth.me().get('prefs')?.colorBlind ?? false,
        isFirstTimeViewingBoard: Controller.isFirstTimeViewingBoard,
        isShowingSidebar: this.model.viewState.get('showSidebar'),
        isShowingWorkspaceNavigation: workspaceNavigationState.value.expanded,
        isTemplate: this.model.isTemplate(),
        labelsState: showLabelsState.value.showText ? 'expanded' : 'collapsed',
        screen: getScreenFromUrl(),
        viewerIsBoardCreator: this.model.get('idMemberCreator') === Auth.myId(),
        visibility: this.model.getPermLevel(),
      },
      containers: formatContainers({
        idBoard: this.model.id,
        idOrganization: this.model.getOrganization()?.id,
      }),
    });

    this.unsubscribeViewFiltersContext = viewFiltersContextSharedState.subscribe(
      () => {
        this.model.filter.viewFiltersContext =
          viewFiltersContextSharedState.value;
      },
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onShortcut = (event: any) => {
    const allowedViewsShortcuts = [Key.f, Key.q, Key.x];
    const key = getKey(event);

    // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    if (showingBoardView() && !allowedViewsShortcuts.includes(key)) {
      return;
    }

    const editable = this.model.editable();
    const isLoggedIn = Auth.isLoggedIn();

    const sendShortcutEvent = (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      shortcutName: any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      { shortcutKey = key, toggleValue }: any = {},
    ) => {
      let source = 'boardScreen';

      if (getCurrentBoardViewSection() === 'timeline') {
        source = 'timelineViewScreen';
      }

      if (getCurrentBoardViewSection() === 'calendar-view') {
        source = 'calendarViewScreen';
      }

      Analytics.sendPressedShortcutEvent({
        shortcutName,
        // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'SourceTyp... Remove this comment to see the full error message
        source: source,
        keyValue: shortcutKey,
        containers: {
          board: { id: this.model.id },
          organization: { id: this.model.get('idOrganization') },
          enterprise: { id: this.model.get('idEnterprise') },
        },
        attributes: {
          toggleValue:
            toggleValue !== undefined ? toggleValue.toLowerCase() : undefined,
        },
      });
    };

    switch (key) {
      case Key.q:
        if (isLoggedIn) {
          const traceId = Analytics.startTask({
            taskName: 'edit-board/filter',
            source: 'boardScreen',
          });

          try {
            this.model.filter.toggleQuietMode();
            event.preventDefault();
            sendShortcutEvent('myCardsShortcut');

            Analytics.taskSucceeded({
              taskName: 'edit-board/filter',
              source: 'boardScreen',
              traceId,
            });
          } catch (error) {
            // @ts-expect-error TS(2345): Argument of type '{ taskName: "edit-board/filter";... Remove this comment to see the full error message
            Analytics.taskFailed({
              taskName: 'edit-board/filter',
              source: 'boardScreen',
              traceId,
            });
          }
        }
        return;

      case Key.x: {
        const traceId = Analytics.startTask({
          taskName: 'remove-boardFilter',
          source: 'boardScreen',
        });

        try {
          this.model.filter.clear();
          event.preventDefault();
          sendShortcutEvent('clearAllFiltersShortcut');

          Analytics.taskSucceeded({
            taskName: 'remove-boardFilter',
            source: 'boardScreen',
            traceId,
          });
        } catch (error) {
          Analytics.taskFailed({
            taskName: 'remove-boardFilter',
            source: 'boardScreen',
            traceId,
            error,
          });
        }

        return;
      }

      case Key.ClosedBracket:
      case Key.w:
        this.toggleSidebar();
        event.preventDefault();
        sendShortcutEvent('toggleBoardMenuDrawerShortcut', {
          toggleValue: this.model.viewState.get('showSidebar')
            ? 'show'
            : 'hide',
        });
        return;

      case Key.SemiColon: {
        const wasShowingLabelText = LabelState.getShowText();
        LabelState.toggleText();
        event.preventDefault();
        const toggleValue = wasShowingLabelText ? 'hide' : 'show';
        sendShortcutEvent('toggleLabelTextShortcut', { toggleValue });
        return;
      }

      case Key.ArrowDown:
      case Key.j:
        this.moveCard('down');
        event.preventDefault();
        sendShortcutEvent('moveDownShortcut');
        return;

      case Key.ArrowUp:
      case Key.k:
        this.moveCard('up');
        event.preventDefault();
        sendShortcutEvent('moveUpShortcut');
        return;

      case Key.ArrowRight:
        this.moveCard('right');
        event.preventDefault();
        sendShortcutEvent('moveRightShortcut');
        return;

      case Key.ArrowLeft:
        this.moveCard('left');
        event.preventDefault();
        sendShortcutEvent('moveLeftShortcut');
        return;

      case Key.n:
        if (editable) {
          const list = this.model.viewState.getList();
          const card = this.model.viewState.getCard();

          if (list != null) {
            const index =
              card != null
                ? list.openCards().indexOf(card) + 1
                : list.openCards().length;

            this.model.composer.save({
              list,
              index,
              vis: true,
            });

            event.preventDefault();
            sendShortcutEvent('insertCardShortcut');
          }
        }
        return;

      case Key.z:
      case Key.Z:
        if (editable) {
          event.preventDefault();
          // Check shiftKey > Key.Z for consistency in case of caps lock.
          if (event.shiftKey) {
            redoAction({ source: 'boardScreen', idBoard: this.model.id });
            sendShortcutEvent('redoActionShortcut', {
              shortcutKey: 'Shift+Z',
            });
          } else {
            undoAction({ source: 'boardScreen', idBoard: this.model.id });
            sendShortcutEvent('undoActionShortcut');
          }
        }
        return;

      case Key.Escape:
        if (editable) {
          if (DragSort.sorting) {
            DragSort.abort();
          } else if (
            !(Layout.isEditing() || PopOver.isVisible || Dialog.isVisible)
          ) {
            if (this.model.composer.get('vis')) {
              this.model.composer.save('vis', false);
            } else if (this.model.viewState.get('listComposerOpen')) {
              this.model.viewState.set('listComposerOpen', false);
            } else {
              this.sidebarViewPromise.then(() => this.sidebarView.popView());
            }
          }

          if (showingCalendar(this)) {
            $('.calendar-day.active').removeClass('active');
          }

          event.preventDefault();
        }
        return;

      default:
        return;
    }
  };

  renderClosed() {
    const org = this.model.getOrganization();
    const isAtOrOverLimit =
      org != null ? org.isAtOrOverFreeBoardLimit() : undefined;

    this.unmountBoardClosed = renderComponent(
      <LazyBoardClosed
        boardId={this.model.get('id')}
        isAtOrOverLimit={isAtOrOverLimit}
      />,
      this.el,
    );
    this.renderBoardBackground();
  }

  render() {
    if (this.model.get('closed')) {
      this.renderClosed();
    } else {
      this.unmountBoardClosed?.();
      this.renderOpen();
    }
    this.renderLabelsPopover();
    this.renderAboutThisBoardModal();
    this.setDynamicTokensOnBoardView();

    return this;
  }

  // Render the new Labels Popover in React.
  renderLabelsPopover() {
    const reactRoot = this.el.querySelector(
      '.js-board-labels-popover-container',
    );
    /**
     * This render function sometimes gets called in rapid succession,
     * too quickly to actually render the component, so check if the unmount
     * function has been defined before rendering again.
     */
    if (reactRoot && !this.unmountLabelsPopover) {
      this.unmountLabelsPopover = renderComponent(
        <LazyLabelsPopover
          idBoard={this.model.id}
          idOrganization={this.model.get('idOrganization')}
          // Since this is rendered on app load, pass in a getter for a fresh
          // editable value to ensure that this is up-to-date when rendered.
          // eslint-disable-next-line react/jsx-no-bind
          isEditable={() => this.model.editable()}
        />,
        reactRoot,
      );
    }
  }

  unmountInlineInspirationsPopoverDiv() {
    if (this.inlineInspirationsPopoverDiv !== null) {
      return ReactDOM.unmountComponentAtNode(this.inlineInspirationsPopoverDiv);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openInlineInspirationsPopover(returnBoardShortLink?: any) {
    if (this.inlineInspirationsPopoverDiv === null) {
      const targetDiv = this.el.querySelector(
        '.inline-inspiration-popover-target',
      );

      if (targetDiv !== null) {
        this.inlineInspirationsPopoverDiv = targetDiv;
      } else {
        $('.board-main-content', this.$el).append(
          '<div class="inline-inspiration-popover-target"></div>',
        );
        this.inlineInspirationsPopoverDiv = this.el.querySelector(
          '.inline-inspiration-popover-target',
        );
      }
    }

    return renderComponent(
      <LazyInlineInspirationsPopover
        boardId={this.model.id}
        orgId={this.model.getOrganization()?.id}
        // eslint-disable-next-line react/jsx-no-bind
        onClose={() => {
          this.inlineInspirationsPopoverDiv?.remove();
        }}
        returnBoardShortLink={returnBoardShortLink}
      />,
      this.inlineInspirationsPopoverDiv,
    );
  }

  renderAboutThisBoardModal() {
    const hasReadMePup = this.model.isPluginEnabled('5d6fd294c2588608fdbf2d33');
    if (
      this.model.get('idMemberCreator') !== Auth.myId() &&
      Auth.confirmed() &&
      Controller.isFirstTimeViewingBoard &&
      !!this.model.get('desc') &&
      !this.model.get('closed') &&
      (!this.model.isTemplate() ||
        (this.model.isTemplate() && this.model.isMember(Auth.me()))) &&
      !hasReadMePup &&
      !isEmbeddedInAtlassian()
    ) {
      Dialog.show({
        reactElement: (
          <AboutThisBoardModal
            idBoard={this.model.id}
            idOrg={this.model.get('idOrganization')}
            onClose={Dialog.hide}
            desc={this.model.get('desc')}
            descData={this.model.get('descData')}
            dateLastActivity={this.model.get('dateLastActivity')}
          />
        ),
        maxWidth: 600,
        displayType: 'about-this-board-modal',
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderConfirmEmailModal({ inviterName }: any) {
    $('#content').append(
      '<div class="board-confirm-email-modal-container"></div>',
    );
    const reactRoot = document.querySelector(
      '.board-confirm-email-modal-container',
    );

    if (reactRoot && !this.unmountConfirmEmailModal) {
      this.unmountConfirmEmailModal = renderComponent(
        <ConfirmEmailModal
          idBoard={this.model.id}
          idOrganization={this.model.get('idOrganization')}
          inviterName={inviterName}
          boardName={this.model.get('name')}
          // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'PIIString... Remove this comment to see the full error message
          email={Auth.me().get('email')}
          dateLastActivity={this.model.get('dateLastActivity')}
          desc={this.model.get('desc')}
          descData={this.model.get('descData')}
          boardOpenCardCount={this.model.openCards().length}
        />,
        reactRoot,
      );
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderJoinBoardModal({ ghost, inviterName }: any) {
    $('#content').append('<div class="join-board-modal-container"></div>');
    const reactRoot = document.querySelector('.join-board-modal-container');

    const signupUrl =
      '/signup?' +
      // @ts-expect-error TS(2345): Argument of type '{ reauthenticate: boolean; retur... Remove this comment to see the full error message
      new URLSearchParams({
        reauthenticate: true,
        returnUrl: `${location.pathname}?completedInviteSignup=1`,
        email: ghost?.get('email') || '',
        fullName: ghost?.get('fullName') || '',
      });

    if (reactRoot && !this.unmountJoinBoardModal) {
      this.unmountJoinBoardModal = renderComponent(
        <JoinBoardModal
          idBoard={this.model.id}
          idOrganization={this.model.get('idOrganization')}
          inviterName={inviterName}
          boardName={this.model.get('name')}
          signupUrl={signupUrl}
          desc={this.model.get('desc')}
          descData={this.model.get('descData')}
          dateLastActivity={this.model.get('dateLastActivity')}
          boardOpenCardCount={this.model.openCards().length}
        />,
        reactRoot,
      );
    }
  }

  renderFilteringStatus() {
    const isFiltering = this.model.filter.isFiltering();

    $('.js-num-cards', this.$el).toggleClass('hide', !isFiltering);
    $('#board', this.$el).toggleClass('filtering', isFiltering);

    // Don't pull in Board Filters and overwrite Query Params if on a Board View
    if (showingBoardView()) {
      return;
    }

    const filterQueryString = this.model.filter.toQueryString();
    const filterQueryParams = new URLSearchParams(filterQueryString);

    const currentQueryParams = new URLSearchParams(location.search);

    // Calling replaceState too many times on a large board render will break
    // the progressive rendering of lists on a board
    if (filterQueryParams.get('filter') !== currentQueryParams.get('filter')) {
      if (filterQueryParams.has('filter'))
        // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
        currentQueryParams.set('filter', filterQueryParams.get('filter'));
      else currentQueryParams.delete('filter');
      // Hack: The URL api auto-encodes commas and colons, but we want to use
      // "invalid" urls with `,` and `:` characters in them.
      const queryString = toQueryStringWithDecodedFilterParams(
        currentQueryParams,
      );
      const query = queryString.length ? `?${queryString}` : '';
      // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
      history.replaceState(null, null, location.pathname + query);
    }
  }

  /**
   * Sets dynamic tokens on the .board-wrapper element.
   * At present, these tokens are used for coloring the board header buttons.
   */
  setDynamicTokensOnBoardView() {
    const {
      backgroundBrightness,
      backgroundColor,
      backgroundTopColor,
      isBackgroundImage,
    } = getBoardBackground(this.model.get('prefs'));
    const { effectiveColorMode } = getGlobalTheme();

    setDynamicTokens({
      element: this.el,
      dynamicTokens: [
        'dynamic.button',
        'dynamic.star',
        'dynamic.text',
        'dynamic.background',
      ],
      background: {
        backgroundBrightness,
        backgroundColor: isBackgroundImage
          ? backgroundTopColor
          : backgroundColor,
        isBackgroundImage,
      },
      colorMode: effectiveColorMode,
    });
  }

  remove() {
    if (this.calendarView != null) {
      this.calendarView.remove();
    }
    unregisterShortcutHandler(this.onShortcut);
    this.unmountTeamOnboardingPupPopover();
    this.unmountTeamOnboardingPupTooltip();
    this.unmountBoardClosed?.();
    this.unmountLabelsPopover?.();
    this.unmountLists?.();
    this.unmountInlineInspirationsPopoverDiv?.();
    this.unmountConfirmEmailModal?.();
    this.unmountJoinBoardModal?.();
    this.removeBoardViewsButton();
    this.removeReactBoardHeader();
    this.removeBritaBoardFilterButton();
    this.removeShowSidebarButton();
    this.removeSubscribedToBoardHeaderIcon();
    this.removeBoardShareButton();
    this.unmountWorkspacesAutoNameAlert();
    this.unmountPluginDropdownList();
    this.unmountPluginHeaderButtons();
    this.globalThemeObserver.unsubscribe();
    this.unsubscribeWorkspaceNavState();
    this.unsubscribeWorkspaceNavHiddenState();
    this.unsubscribeViewFiltersContext();

    return super.remove(...arguments);
  }

  // Because we are using mouse event handlers that stop propagation on mousedown events
  // (enableDragScroll.ts and jquery.sortable), we need to handle blurring of inputs
  // and textareas ourselves.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  blurInputsOnBoardClick(e: any) {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $target = $(e.target);

    // Ignore clicks on inputs and textareas. Note that inputs here can also be submit buttons
    // that are 'programmatically' clicked by the DOM upon form submission (on enter keypress)
    const clickedInput = $target.is('input') || $target.is('textarea');
    if (clickedInput) {
      return e?.stopPropagation();
    } else {
      return $('input, textarea').blur();
    }
  }

  /**
   * Normally, we evaluate mouse move to determine which card is currently
   * "selected", which essentially means the card gets hover styling, and that
   * keyboard shortcuts apply to it. Under the following circumstances, we don't
   * want that to happen. This is critical for things like maintaining a card's
   * "selected" state when a popover is opened in the quick edit menu.
   */
  _ignoreMouseMove() {
    return (
      this.ignoreMouseCardSelects ||
      PopOver.isVisible ||
      DragSort.sorting ||
      LabelsPopoverState.value.isOpen
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showBoardDetailView(args: any) {
    return Promise.try(() => {
      let date, idCard, member;
      const board = this.model;

      if ((idCard = args.idCard) != null) {
        Controller.showCardOnBoard(
          idCard,
          args.highlight,
          board,
          args.replyToComment,
          args.loadCardData,
        );
      } else if (
        args.usernameBoardProfile &&
        (member = board.modelCache.findOne(
          'Member',
          'username',
          args.usernameBoardProfile,
        )) != null
      ) {
        this.showMemberProfile(member);
      } else if (['power-up', 'power-ups'].includes(args.section)) {
        const powerUpViewsEnabled = featureFlagClient.get(
          'ecosystem.power-up-views',
          false,
        );
        if (args.powerUpViewKey && powerUpViewsEnabled) {
          this.showPowerUpView({
            idPlugin: args.directoryIdPowerUp,
            viewKey: args.powerUpViewKey,
          });
        } else if (board.editable()) {
          this.showDirectory(
            args.directorySection,
            args.directoryCategory,
            args.directoryIdPowerUp,
            args.directoryIsEnabling,
          );
        } else {
          setBoardLocation(board.id);
        }
      } else if (args.section === 'map') {
        if (!board.isMapPowerUpEnabled()) {
          const boardUrl = getBoardUrl(board.id);
          navigate(boardUrl, { trigger: true });
        } else {
          this.showMap({
            mapCenterTo: args.mapCenterTo,
            zoom: args.zoom,
          });
        }
      } else if (args.section === 'dashboard') {
        this.showDashboard();
      } else if ((date = args.calendarDate) != null) {
        this.showCalendar(date);
      } else if (args.section === 'butler' && args.reportType) {
        this.showAutomaticReports(args.reportType);
      } else if (args.section === 'butler') {
        this.showButlerView({
          butlerTab: args.butlerTab,
          butlerCmdEdit: args.butlerCmdEdit,
          butlerCmdLog: args.butlerCmdLog,
          newCommand: args.butlerNewCommand,
          butlerUsage: args.butlerUsage,
          butlerAccount: args.butlerAccount,
          newIcon: args.butlerNewIcon,
          newLabel: args.butlerNewLabel,
          taskId: args.taskId,
          source: args.source,
        });
      } else if (args.section === 'table') {
        this.showTable();
      } else if (args.section === 'timeline') {
        this.showTimeline();
      } else if (args.section === 'calendar-view') {
        this.showCalendarView();
      } else {
        if (args.openListComposer) {
          this.openListComposer();
        }
        if (args.openCardComposerInFirstList) {
          // Deferred to ensure "Add a card" button below composer is hidden properly
          _.defer(() => this.openCardComposerInFirstList());
        }
        const extra = args.referrerUsername
          ? [args.referrerUsername, 'recommend']
          : undefined;
        const search = getQueryParamsToKeepOnBoardView();
        setBoardLocation(board.id, args.section, extra, { search });
      }

      return this;
    });
  }
}

BoardView.initClass();
export { BoardView };
